import { UpdateAgentQuery } from "@/api/graphql/agents/update/mutations";
import { getGraphqlClient } from "@/api/graphql/client.ts";
import type { AccountsMsUpdateSupportUserRequest } from "@/api/graphql/types/graphql.ts";

export const updateAgentMutation = async (
  request: AccountsMsUpdateSupportUserRequest,
) => await getGraphqlClient().request(UpdateAgentQuery, { request });
